import { useState, useEffect } from "react";
import content from "app-content";
import getA11yFulfilmentString from "./getA11yFulfilmentString";

const ONE_SECOND = 1000;

const useChangeTracking = ({ source, seller }) => {
  const fulfilment = getA11yFulfilmentString({ source, seller });

  const [details, setDetails] = useState(fulfilment);
  const [output, setOutput] = useState(null);

  useEffect(() => {
    if (fulfilment !== details) {
      setDetails(fulfilment);

      setOutput(
        `${content.saved_items_accessibility_seller_change}${
          fulfilment ? `: ${fulfilment}` : ""
        }`
      );
      setTimeout(() => {
        setOutput(null);
      }, ONE_SECOND);
    }
  }, [fulfilment]);

  return output;
};

export default useChangeTracking;
